import { red, blue, green, purple, pink, yellow } from '@mui/material/colors';

export const obtenerEstadoTrafico = (carga, nivel_trafico) => {
    let estado = {
        nombre: '',
        color: ''
    };

    if (nivel_trafico === 3) {
        if (carga > 90) {
            estado.nombre = "Retenciones";
            estado.color = red[500];
        } else if (carga > 50) {
            estado.nombre = "Tráfico intenso";
            estado.color = yellow[800];
        } else if (carga > -1) {
            estado.nombre = "Tráfico fluido";
            estado.color = green[400];
        } else {
            estado.nombre = "Sin datos";
            estado.color = purple[500];
        }
    } else if (nivel_trafico === 5) {
        if (carga > 75) {
            estado.nombre = "Congestión";
            estado.color = red[500];
        } else if (carga > 60) {
            estado.nombre = "Muy Denso";
            estado.color = pink[500];
        } else if (carga > 50) {
            estado.nombre = "Denso";
            estado.color = yellow[500];
        } else if (carga > 25) {
            estado.nombre = "Fluido";
            estado.color = green[500];
        } else if (carga > -1) {
            estado.nombre = "Muy Fluido";
            estado.color = blue[500];
        } else {
            estado.nombre = "Sin datos";
            estado.color = purple[500];
        }
    }

    return estado;
};

export const obtenerEstado = async (trafico, tam, nivel_trafico) => {
    let por_bueno = 50
    let por_malo = 50
    try {
        const response = await fetch("/config.json");
        const configuration = await response.json();
        por_bueno = configuration["PORCENTAJE_BUENO"]
        por_malo = configuration["PORCENTAJE_MALO"]
    } catch (error) {
        console.error("Error de configuración:", error);
    }
    const counts = trafico.map(row => row.length);
    if (nivel_trafico === 3) {
        if (((counts[2]/tam) * 100 ) > por_malo) return 'Retenciones';
        if (((counts[1]/tam) * 100 )  > por_bueno) return 'Tráfico Intenso';
        return 'Bueno';
    } else {
        if (((counts[0] + counts[1]/tam) * 100 ) > por_malo) return 'Retenciones';
        if (((counts[2]/tam) * 100 )  > por_bueno) return 'Tráfico Intenso';
        return 'Muy Fluido';
    }
};